import { Field, LinkFieldValue, RichTextField } from '@sitecore-jss/sitecore-jss-nextjs';
import {
  RenderingProps,
  DynamicPlaceholderParams,
  TranslationOptionsParams,
  AnchorTargetParams,
} from 'src/shared/shared.types';

export type C09AZIndexProps = RenderingProps<C09AZIndexFields, C09AZIndexParams>;

export type C09AZIndexFields = {
  data?: {
    azIndex?: AZIndexFields;
  };
};

export type AZIndexFields = {
  headline?: {
    jsonValue?: Field<string>;
  };
  topSupportCopy?: {
    jsonValue?: RichTextField;
  };
  bottomSupportCopy?: {
    jsonValue?: RichTextField;
  };
  azIndexItems?: {
    results?: Array<AZIndexItemFields>;
  };
};

export type AZIndexItemFields = {
  letter?: {
    jsonValue?: Field<string>;
  };
  links?: {
    jsonValue?: {
      value?: Array<LinkFieldValue>;
    };
  };
};

export type C09AZIndexParams = {
  TitleType?: string;
  TopContentAlignment?: string;
  Background?: string;
} & DynamicPlaceholderParams &
  TranslationOptionsParams &
  AnchorTargetParams;
